import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getMailTemplates = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/mail-templates/all`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const getSingleMailTemplate = (mailTemplateId) => {
   return axios({
      method: "GET",
      url: `${hostCloud}/mail-templates`,
      headers: {
         Accept: "*/*"
      },
      params: {
         mailTemplateId
      }
   });
};

export const getNewsletters = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/newsletters/all/active`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const saveTemplate = async (content, name, subject, coverPhotoURL) => {
   return axios({
      method: "post",
      url: `${hostCloud}/mail-templates`,
      headers: {
         Accept: "*/*"
      },
      data: {
         htmlContent: content,
         name: name,
         subject: subject,
         coverPhotoURL
      }
   });
};

export const deleteTemplate = async (templateId) => {
   return axios({
      method: "DELETE",
      url: `${hostCloud}/mail-templates`,
      headers: {
         Accept: "*/*"
      },
      params: {
         mailTemplateId: templateId
      }
   });
};

export const checkIfTemplateExist = async (nameOfTemplate) => {
   return axios({
      method: "GET",
      url: `${hostCloud}/mail-templates/exists`,
      headers: {
         Accept: "*/*"
      },
      params: {
         name: nameOfTemplate
      }
   });
};

export const updateTemplate = async (templateId, name, subject, content, coverPhotoURL) => {
   return axios({
      method: "PUT",
      url: `${hostCloud}/mail-templates`,
      headers: {
         Accept: "*/*"
      },
      data: {
         id: templateId,
         name: name,
         subject: subject,
         htmlContent: content,
         coverPhotoURL
      }
   });
};

export const sendNewsletterWithSubs = async (newsletterId, id, subs) => {
   return axios({
      method: "put",
      url: `${hostCloud}/newsletters/list?newsletterId=${newsletterId}&subscribentsIds=${subs}&mailTemplateId=${id}`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      }
   });
};
export const sendNewsletterToEmailsFromList = async (from, templateId, emailList) => {
   return axios({
      method: "put",
      url: `${hostCloud}/newsletters/list-b2`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      },
      data: {
         from: from,
         mailTemplateId: templateId,
         to: emailList
      }
   });
};
export const sendNewsletterWithCSV = async (file) => {
   return axios({
      method: "put",
      headers: {
         Accept: "*/*",
         "Content-Type": "multipart/form-data;"
      },
      url: `${hostCloud}/newsletters/csv`,
      data: file
   });
};
export const sendNewsletterToEmailsFromCSV = async (email, mailTemplateId, file) => {
   return axios({
      method: "put",
      headers: {
         Accept: "*/*",
         "Content-Type": "multipart/form-data;"
      },
      url: `${hostCloud}/newsletters/csv-b2?from=${email}&mailTemplateId=${mailTemplateId}`,
      data: file
   });
};
